import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { Nullable } from '@models/common.model';
import moment from 'moment';

@Pipe({
    name: 'relativeTime',
    standalone: true,
})
export class RelativeTimePipe implements PipeTransform {
    constructor(@Inject(LOCALE_ID) private readonly _locale: string) {}

    /**
     * Transform value to relative time
     * Example: 1 minute ago, 1 hour ago, 1 day ago
     * If value is null, return empty string
     *
     * @param {Nullable<string>} value
     * @return {*}  {string}
     * @memberof RelativeTimePipe
     */
    transform(value: Nullable<string>): string {
        if (!value) {
            return '';
        }
        return moment(value).locale(this._locale).fromNow().toUpperFirstCharacter();
    }
}
